import __base_store from '@/store/__base_store'

/**
 * Store de cuotas (modelo `cuota`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'cuota',
	},
})

